<template>
    <div class="register-info-user">
        <el-card shadow="always">
            <el-form ref="form" :model="form" label-position="left" label-width="" :rules="rules">
                <el-form-item label="" prop="email">
                    <el-input 
                        type="text" 
                        :placeholder="$t('Placeholder.EnterEmail')" 
                        v-model.trim="form.email" 
                        clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="" prop="password">
                    <el-input 
                        type="password" 
                        :placeholder="$t('Placeholder.EnterPassword')" 
                        v-model.trim="form.password" 
                        clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="" prop="confirmPassword">
                    <el-input 
                        type="password" 
                        :placeholder="$t('Placeholder.EnterConfirmPassword')" 
                        v-model.trim="form.confirmPassword"
                        clearable>
                    </el-input>
                </el-form-item>
                <div class="card-footer">
                    <el-button v-waves class="card-btn-next" type="primary" @click="handleNextStepClick">{{ $t('Button.Next') }}</el-button>
                </div>
                <div class="form-card-change-sign">
                    {{ loginText }}<el-button type="text" size="default" @click="toLogin">{{ loginBtnText }}</el-button>
                </div>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import waves from '@/directive/waves' // Waves directive
import { validate_email, validate_password, validate_confirmPassword } from '@/utils/validate/register'
import { FormMixin } from '@/mixins'
import { setObjectMapData } from '@/utils'

export default {
    props: {
        title: { type: String, default: '' },
        userInfo: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    name: 'UserInfoCard',
    directives: { waves },
    mixins: [FormMixin],
    data() {
        return {
            form: {
                email: '',
                password: '',
                confirmPassword: '',
            },
            rules: {
                email: { validator: validate_email.bind(this), trigger: 'blur' },
                password: { validator: validate_password.bind(this), trigger: 'blur' },
                confirmPassword: { validator: validate_confirmPassword.bind(this), trigger: 'blur' },
            },
        }
    },
    created() {
        if (this.userInfo) {
            this.form = setObjectMapData(this.userInfo, this.form)
        }
    },
    computed: {
        ...mapGetters(['size', 'language']),
    },
    methods: {
        handleNextStepClick() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$emit('nextStep', this.form)
                } else {
                    this.$emit('nextStep', false)
                    return false
                }
            })
        },
    },
    watch: {
        language(language) {
            if (language) {
                this.$refs.form.resetFields()
            }
        },
    },
}
</script>

<style lang="scss" scoped>
$color-theme: #4da1ff;

.card-footer {
    .card-btn-next {
        width: 100%;
    }
}
.form-card-change-sign {
    font-size: 14px;
    color: #666;
    margin-top: 10px;
} // 切换注册登录
</style>
